import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CartFunnelRadioItemBlockConfig } from '@front-platform/content-builder';
import { cartFunnelRadioItemBlockResolveConfig } from '@front-platform/content-builder';
import { Component, OnInit, input } from '@angular/core';

import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';
export interface CartFunnelRadioItemBlockRuntimeConfig {
  'block_id'?: string;
  'form_id'?: string;
}

export type CartFunnelRadioItemBlockConfigInput = Partial<
  Omit<CartFunnelRadioItemBlockConfig, keyof CartFunnelRadioItemBlockRuntimeConfig> &
    CartFunnelRadioItemBlockRuntimeConfig
>;
export type CartFunnelRadioItemBlockResolvedConfig = Omit<
  CartFunnelRadioItemBlockConfig,
  keyof CartFunnelRadioItemBlockRuntimeConfig
> &
  Partial<CartFunnelRadioItemBlockRuntimeConfig>;
export interface CartFunnelRadioItemBlockContract extends ConfigComponentContract<
  CartFunnelRadioItemBlockConfigInput,
  CartFunnelRadioItemBlockResolvedConfig
> {}

@Component({
  selector: 'app-cart-funnel-radio-item-block',
  templateUrl: './cart-funnel-radio-item-block.component.html',
  standalone: false,
})
export class CartFunnelRadioItemBlockComponent implements OnInit, CartFunnelRadioItemBlockContract {
  readonly config = input<CartFunnelRadioItemBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CartFunnelRadioItemBlockConfig,
    CartFunnelRadioItemBlockRuntimeConfig
  >(cartFunnelRadioItemBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string {
    return this.resolvedConfig()['title'] as unknown as string;
  }
  get required(): boolean {
    return this.resolvedConfig()['required'] as unknown as boolean;
  }
  get customTitle(): string | undefined {
    return this.resolvedConfig()['custom_title'] as unknown as string | undefined;
  }
  get displayCustomTitleInComment(): boolean {
    return this.resolvedConfig()['display_custom_title_in_comment'] as unknown as boolean;
  }
  get displayTitleInComment(): boolean {
    return this.resolvedConfig()['display_title_in_comment'] as unknown as boolean;
  }
  get options(): any {
    return this.resolvedConfig()['options'] as unknown as any;
  }
  get blockId(): string {
    return this.resolvedConfig()['block_id'] as unknown as string;
  }
  get formId(): string {
    return this.resolvedConfig()['form_id'] as unknown as string;
  }

  constructor(private cartFunnelDispatcher: CartFunnelStoreDispatcher) {}

  ngOnInit(): void {
    this.cartFunnelDispatcher.addValue({
      id: this.blockId,
      title: this.title,
      formId: this.formId,
      required: this.required,
      displayTitle: this.displayTitleInComment,
      customTitle: this.customTitle,
      displayCustomTitleInComment: this.displayCustomTitleInComment,
    });
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CartFunnelRadioItemBlockComponent, {
  'keyAliases': {},
});
